module.exports = __webpack_public_path__ + "img/soil-station.03062a34.png";